import { POST,postFile } from "../../index";

export const SelectBatteryPage = (param) => POST("/v1/BigDataAnalysisController/battery/SelectBatteryPage", param);
export const queryBatteryCountDrawing = (param) => POST("/v1/BigDataAnalysisController/battery/queryBatteryCountDrawing", param);
export const queryBatteryOrganizationPage = (param) => POST("/v1/BigDataAnalysisController/battery/queryBatteryOrganizationPage", param);
export const queryBatterySinglePage = (param) => POST("/v1/BigDataAnalysisController/battery/queryBatterySinglePage", param);
